import { Component } from '@angular/core';
import { AgefiphService } from 'src/app/services/agefiph.service';

@Component({
    selector: 'app-question-image',
    templateUrl: './question-image.component.html',
    styleUrls: ['./question.component.scss']
})
export class QuestionImageComponent {

    constructor(public agefiphService: AgefiphService) {

    }
}
